import { type ReactNode, useState } from 'react';

import { PageHelpContext, PageHelpScopeContext, PageHelpStore } from '../utils/page-help-store';

/** Wraps the catalog-v2 area so pages and their tabs share one help panel. */
export function PageHelpProvider({ children }: { children: ReactNode }) {
  const [store] = useState(() => new PageHelpStore());
  return <PageHelpContext.Provider value={store}>{children}</PageHelpContext.Provider>;
}

/** Marks the ⓘ it wraps as the PAGE's help (the entity header's), not a card's. */
export function PageHelpScope({ children }: { children: ReactNode }) {
  return <PageHelpScopeContext.Provider value={true}>{children}</PageHelpScopeContext.Provider>;
}
